// Shared constants for the Customers (Shop Approval) module.
export const STATUS = {
  approved: "bg-[#E7F3EA] text-[#1F5B2E] border border-[#BFDCC7]",
  pending: "bg-[#FBF1DF] text-[#7A4B12] border border-[#E7D0A8]",
  rejected: "bg-[#FBE7E7] text-[#7A1F1F] border border-[#E7B9B9]",
};
export const ORDER_STATUS_LABELS = {
  pending_approval: "Pending Approval", approved: "Approved", processing: "Processing",
  payment_confirmed: "Processing", shipped: "Shipped", completed: "Completed",
  rejected: "Rejected", cancelled: "Cancelled",
};
export const ORDER_STATUS_STYLE = {
  pending_approval: "bg-[#FBF1DF] text-[#7A4B12] border border-[#E7D0A8]",
  approved: "bg-[#EAF1F7] text-[#1E3E5C] border border-[#C7D7E6]",
  processing: "bg-[#E7F3EA] text-[#1F5B2E] border border-[#BFDCC7]",
  payment_confirmed: "bg-[#E7F3EA] text-[#1F5B2E] border border-[#BFDCC7]",
  shipped: "bg-[#EDE7F7] text-[#4B2E7A] border border-[#D0C7E7]",
  completed: "bg-[#E7F3EA] text-[#1F5B2E] border border-[#BFDCC7]",
  cancelled: "bg-[#F0E9E9] text-[#5A4A4A] border border-[#DDD0D0]",
};
export const EMPTY_ADDR = { line1: "", line2: "", city: "", state: "", pincode: "" };
export const TIERS = { Standard: 0, Silver: 5, Gold: 10, Platinum: 15 };
